import { gql } from 'src/__generated__';

export const GET_LICENCES = gql(`
  query GetLicences($languageCode: LanguageCodeIso, $zone: Zone) {
    viewer {
      _id
      licences(languageCode: $languageCode, zone: $zone) {
        ...licence
      }
    }
  }
`);
